export default "__VITE_ASSET__Bykmdu88__"